var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKutxis2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6109 0.910156H5.05533C4.84037 0.910156 4.66643 1.0841 4.66643 1.29906C4.66643 1.51402 4.84037 1.68796 5.05533 1.68796H12.6721L0.113697 14.2464C-0.0382245 14.3983 -0.0382245 14.6444 0.113697 14.7963C0.18964 14.8722 0.289171 14.9102 0.388666 14.9102C0.488161 14.9102 0.587656 14.8722 0.663635 14.7963L13.222 2.23786V9.85463C13.222 10.0696 13.3959 10.2435 13.6109 10.2435C13.8259 10.2435 13.9998 10.0696 13.9998 9.85463V1.29906C13.9998 1.0841 13.8258 0.910156 13.6109 0.910156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKutxis2);
export default __webpack_public_path__ + "static/media/kutxis2.a9aa2c4a8ad38bab568feefe240490ed.svg";
export { ForwardRef as ReactComponent };